const state = {
  joinProcedures: [],
  joinProcedure: {},
};

export default state;
